import Box from '@mui/material/Box';
import type { BoxProps } from '@mui/material/Box';
import { getSafeHtml, type SafeHtmlPolicy } from '@/lib/securityValidation';

type SafeHtmlProps = Readonly<
  Omit<BoxProps, 'dangerouslySetInnerHTML' | 'children'> & {
    html: string;
    /** `'report'` keeps `<style>` / inline styles for SSRS clinical summaries. */
    policy?: SafeHtmlPolicy;
  }
>;

/**
 * Renders HTML after sanitizing with DOMPurify via getSafeHtml.
 * The single allowed dangerouslySetInnerHTML call site for Semgrep.
 */
export function SafeHtml({ html, policy = 'default', component = 'div', ...rest }: SafeHtmlProps) {
  const sanitized = getSafeHtml(html, policy);
  return (
    <Box
      component={component}
      {...rest}
      // nosemgrep: eslint.react-dangerouslysetinnerhtml
      dangerouslySetInnerHTML={{ __html: sanitized }} // nosemgrep: eslint.react-dangerouslysetinnerhtml -- DOMPurify via getSafeHtml
    />
  );
}
